import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { CompanyClusterProgrammerCompanyDto, companyClusterProgrammerCompanyValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion } from 'components'

interface ClusterProgrammerCompanyAddEditDialogProps {
  initialValues: CompanyClusterProgrammerCompanyDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function ClusterProgrammerCompanyAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: ClusterProgrammerCompanyAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={companyClusterProgrammerCompanyValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Cluster Programmer Company</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.clusterProgrammerCompanyCode && errors.clusterProgrammerCompanyCode)}
                      helperText={touched.clusterProgrammerCompanyCode && errors.clusterProgrammerCompanyCode}
                      label='Cluster Programmer Company Code'
                      name='clusterProgrammerCompanyCode'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.clusterProgrammerCompanyCode}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <ExplanationAccordion variant='outlined'>
                      ||All fields are required.|| Cluster Programmer Company Code must be 3 characters. ||
                    </ExplanationAccordion>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={loading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
